import React, { useState, useEffect, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
   
  Button,
   
  
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { useTranslation } from "react-i18next";
//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "adjustment";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ProductsLotAdjustmentModal = ({ handleClose, open, addProduct,FacilityId, ...props }) => {
  const { t } = useTranslation();
  const tblLotRefHolder = useRef({ table: null });
  const tblLotRef = tblLotRefHolder.current;
  const ItemGroupId = props.formData.ItemGroupId;
  const TransactionDate = props.formData.TransactionDate; 
  const AdjTypeId = props.formData.AdjTypeId; 
  // const { isLoading, error, isError, data, refetch } = useQuery(
  //   "products_lot",
  //   api.getProductsLotAdjustment
  // );
  const [tabledata, setTabledata] = useState([]); 
  const { isLoading, error, isError, data, refetch } =  useQuery(['products_lot', FacilityId, ItemGroupId, TransactionDate, AdjTypeId], () =>
    api.getProductsLotAdjustment(FacilityId, ItemGroupId, TransactionDate, AdjTypeId).then((res) => {
      setTabledata(res);
      return res?.data ?? null;
    }), {
    enabled: Boolean(FacilityId, ItemGroupId, TransactionDate, AdjTypeId)
  })



  const [selectedProducts, setselectedProducts] = useState([]);

  const ProductColumns = [
    { title: "id", field: "ItemNo", visible: false },
    { title: "ItemNo", field: "ItemNo", visible: false },

    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:50, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: t(DispensingLanguage[lan][menukey]['Product Code']), field: "ItemCode", width: 140, headerFilter:true },
    { title: t(DispensingLanguage[lan][menukey]['Product Name']), field: "ItemName", headerFilter:true  },
    {
      title: t(DispensingLanguage[lan][menukey]['Lot Qty']),
      field: "CurrentStockQty",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
       
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Lot No']),
      field: "BatchNo",
      width: 100,
      
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Expiry Date']),
      field: "ExpiryDate",
      width: 100 
    },
    { 
      title: "SourceId",
      field: "SourceId",
      visible: false,
    },
    { 
      title: t(DispensingLanguage[lan][menukey]['Source']),
       field: "SourceName",
       width: 120
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Unit Price (CFA)']),
      field: "UnitPrice",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
       
    } 
  ];

  
  const ProdustDataItemsLot = tabledata?.map((item, index) => { 
    return item;
  });

  let selectedRows = [];
  
  const [btnDisable, setbtnDisable] = useState(false);
  const SaveSelectedProducts = () => { 

    //console.log("All Product >>>> ",ProdustDataItemsLot);
    //console.log("Product modal selected product >>>> ",tblLotRef.table.getSelectedData());

    if(tblLotRef.table.getSelectedData().length>0){
      setbtnDisable(true);
      selectedRows = tblLotRef.table.getSelectedData();
      checkExpiringBatches();
      addProduct(tblLotRef.table.getSelectedData());  
      setTimeout(() => setbtnDisable(false), 500);
    }  
  };


   const checkExpiringBatches = () => {
   
    let count = 0;
    console.log("ProdustDataItemsLot ", ProdustDataItemsLot);
    // removing current selected rows
     let rowsWithoutSelected = ProdustDataItemsLot.filter((o) => {
      for (var i = 0; i < selectedRows.length; i++) {
        if (
          selectedRows[i].ItemCode === o.ItemCode &&
          selectedRows[i].ExpiryDate === o.ExpiryDate
        ) {
          return false;
        }
      }
      return true;
    });

   //console.log("removing current selected rows", rowsWithoutSelected);
   //console.log("props ManyTableData ", props.ManyTableData);


    // removing already selected rows in many grid
    if (props.ManyTableData) {
      rowsWithoutSelected = rowsWithoutSelected.filter((o) => {
        for (var i = 0; i < props.ManyTableData.length; i++) {
          if (
            props.ManyTableData[i].ItemCode === o.ItemCode &&
            props.ManyTableData[i].ExpiryDate === o.ExpiryDate
          ) {
            return false;
          }
        }
        return true;
      });
    }

    //console.log("rowsWithoutSelected: ", rowsWithoutSelected);


    rowsWithoutSelected.forEach((p) => {
      const expiringProds = selectedRows.filter((o) => {
        //console.log("o.ExpiryDate== ", o.ItemCode, "====", o.ExpiryDate);
        
        

        if (o.ItemCode === p.ItemCode) {

          if (new Date(o.ExpiryDate, "DD/MM/YYYY") > new Date(p.ExpiryDate, "DD/MM/YYYY")) {
            return true;
          }
        } else {
          return false;
        }
      });

      //console.log("Expiring products: ", expiringProds);

      if (expiringProds.length > 0) {
        count++;
      }
    });

    

     if (count > 0) {
      props.openNoticeModal({
        isOpen: true,
        msg: t(DispensingLanguage[lan][menukey]['Some of your product batches expiring before your selected ones, please select batches which will expire early.']),
        msgtype: 0,
        duration: 10000,
      });
      return;
    } 

 
  }; 

  const checkSelect = (row) => { 
    console.log(row);
    console.log("row");
  };

  useEffect(() => {
    if (tblLotRef.table == null) return;



}, []);
  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('Products')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md" 
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('Products')}
        >
          {t(DispensingLanguage[lan][menukey]['Products Lot'])} 
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            onRef={(rf) => { tblLotRef.table = rf.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: true,
             }}
            columns={ProductColumns}
            data={ProdustDataItemsLot}
            height="300px"
            layout={"fitColumns"}
            //selectableCheck={(row)=>checkSelect(row)}


          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={btnDisable}
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
            {t(DispensingLanguage[lan][menukey]['ADD'])}  
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose('Products')}
          >
           {t(DispensingLanguage[lan][menukey]['CANCEL'])}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default ProductsLotAdjustmentModal;
